import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Input as KitInput } from '@telus/koodo-ui-kit'
import { useSelector } from 'react-redux'
import Sites from '@sites/index'
import { getById, getBySlug } from '@apps/utils/contentful'

const PostalCode = ({
 testId, onBlur, onChange, value, error 
}) => {

  const POSTAL_CODE_LENGTH = '7'

  const {
    content: { pageContent },
    user: { selectedLanguage },
    userType
  } = useSelector((state) => state.common)

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const textContent = useMemo(() => {
    if (!pageContent) return {}
    const phoneNumberPage = getById(pageContent, `phoneNumberPage${pagePrefix}`)[selectedLanguage]
    const { shortTextFields } = phoneNumberPage || {}
    return {
      postalCodeLabel: getBySlug(shortTextFields, 'postalCodeLabel')?.value
    }
  }, [pageContent, selectedLanguage])

  const { postalCodeLabel } = textContent

  return (
    <div className="w-full">
      <KitInput
        type="text"
        id="postalCode"
        label={postalCodeLabel}
        name="postalCode"
        value={value}
        onBlur={() => onBlur()}
        onChange={(payload) => {
          const event = payload?.target
            ? payload
            : { target: { value: typeof payload === 'string' ? payload : payload?.value || '' } }
          onChange(event)
        }}
        feedback={error}
        validation={error ? 'error' : undefined}
        maxLength={POSTAL_CODE_LENGTH}
        data-testid={testId}
      />
    </div>
  )
}

PostalCode.prototype = {
  children: PropTypes.string,
  onChange: PropTypes.func
}

export default PostalCode
